/* BAINELYS — Sticky Add to Cart (mobile) */
'use strict';

(function () {
  const bar     = document.querySelector('[data-sticky-atc]');
  const mainBtn = document.querySelector('[data-atc-btn]');
  const footer  = document.querySelector('.footer');
  if (!bar || !mainBtn) return;

  let pastMainBtn  = false;
  let footerInView = false;

  function refresh() {
    bar.classList.toggle('is-visible', pastMainBtn && !footerInView);
  }

  const btnObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => { pastMainBtn = !entry.isIntersecting; });
    refresh();
  }, { threshold: 0 });

  btnObserver.observe(mainBtn);

  if (footer) {
    const footerObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => { footerInView = entry.isIntersecting; });
      refresh();
    }, { threshold: 0, rootMargin: '0px 0px -1px 0px' });

    footerObserver.observe(footer);
  }

  const stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
  stickyBtn?.addEventListener('click', () => {
    mainBtn.closest('form')?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });
})();
